export enum DisplayedPublicationType {
  NON_DETECTED = 'Catégorie non détectée',
}
